export default {
  purchaseDate: {
    id: 'insurance_policy_details_purchase_date',
    defaultMessage: 'Purchased on {date}',
  },
  imei: {
    id: 'insurance_policy_details_imei',
    defaultMessage: 'IMEI: {imei}',
  },
  coverageSince: {
    id: 'insurance_policy_details_coverage_since',
    defaultMessage: 'Coverage since',
  },
  expires: {
    id: 'insurance_policy_details_expires',
    defaultMessage: 'Expires',
  },
  backLabel: {
    id: 'insurance_policy_details_back_label',
    defaultMessage: 'All Protection Plans',
  },
  cancellationReason: {
    id: 'insurance_policy_details_cancellation_reason',
    defaultMessage: 'Cancellation reason',
  },
  serialNumber: {
    id: 'insurance_policy_details_serial_number',
    defaultMessage: 'Serial number: {serialNumber}',
  },
  policyWithdrawal: {
    id: 'cancelation_reason_policyholder',
    defaultMessage: 'Canceled by policyholder',
  },
  policyCancellation: {
    id: 'cancelation_reason_policyholder',
    defaultMessage: 'Canceled by policyholder',
  },
  orderlineWithdrawal: {
    id: 'cancelation_reason_orderline_refunded',
    defaultMessage: 'Device returned',
  },
  orderlineCancellation: {
    id: 'cancelation_reason_orderline_refunded',
    defaultMessage: 'Device returned',
  },
  orderlineReturn: {
    id: 'cancelation_reason_orderline_refunded',
    defaultMessage: 'Device returned',
  },
  failingPaymentOccurrence: {
    id: 'cancelation_reason_unpaid_premium',
    defaultMessage: 'Payment not made',
  },
  theft: {
    id: 'cancelation_reason_theft',
    defaultMessage: 'Stolen device',
  },
  death: {
    id: 'cancelation_reason_policyholder',
    defaultMessage: 'Canceled by policyholder',
  },
  riskDisappearance: {
    id: 'cancelation_reason_risk_disappearence',
    defaultMessage: 'Device lost',
  },
  other: {
    id: 'cancelation_reason_insurer',
    defaultMessage: 'Canceled by insurer',
  },
  chargeback: {
    id: 'cancelation_reason_insurer',
    defaultMessage: 'Canceled by insurer',
  },
  fraud: {
    id: 'cancelation_reason_insurer',
    defaultMessage: 'Canceled by insurer',
  },
  replacement: {
    id: 'cancelation_reason_replacement',
    defaultMessage: 'Coverage limit reached',
  },
}
